import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Spin, Input } from 'antd';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';

import palette from 'palette';
import { FormikInputFieldWithLabel } from 'elements/FormikInputFieldWithLabel';
import { FormikCheckboxWithLabel } from 'elements/FormikCheckboxWithLabel';
import adminSelectors from 'store/admin/selectors';
import { ConnectorBase, ConnectorsFieldName } from 'pages/Connectors/types';
import { StyledButtons, StyledContentForm, StyledEditBlock } from './styles';
import { SelectConnectionType } from '../../SelectConnectionType';

interface CreateContentProps {
  onSubmitForm: (values: ConnectorBase) => void;
  state: any;
}

export const UpdateContent: FC<CreateContentProps> = ({ onSubmitForm, state }) => {
  const isCreateGroupLoading = useSelector(adminSelectors.groups.isCreateGroupLoading);
  const { t } = useTranslation();

  const validationSchema = () => true;

  return (
    <Formik<ConnectorBase>
      initialValues={{
        name: state.name,
        enabled: state.enabled,
        connectionType: state.connectionType,
      }}
      onSubmit={(submittedValues) => {
        onSubmitForm({
          ...submittedValues,
        });
      }}
    >
      {({ values, handleChange, handleSubmit, handleReset, setFieldValue, errors }) => (
        <StyledContentForm onSubmit={handleSubmit} onReset={handleReset}>
          <Spin spinning={isCreateGroupLoading}>
            <StyledEditBlock>
              <FormikInputFieldWithLabel
                name={ConnectorsFieldName.name}
                onChange={handleChange}
                label={t('infoFields.name')}
                defaultValue={values.name}
              />
              <SelectConnectionType value={state.connectionType} onChange={handleChange} />
              <FormikCheckboxWithLabel
                name={ConnectorsFieldName.enabled}
                onChange={handleChange}
                label={t('infoFields.enabled')}
                defaultValue={values.enabled || true}
              />
            </StyledEditBlock>
          </Spin>
          <StyledButtons>
            <Button htmlType="submit" style={{ color: palette.white.w1, backgroundColor: palette.blue.b1 }}>
              {t('common.apply')}
            </Button>
            <Button onClick={handleReset} style={{ color: palette.white.w1, backgroundColor: palette.red.r3 }}>
              {t('common.cancel')}
            </Button>
          </StyledButtons>
        </StyledContentForm>
      )}
    </Formik>
  );
};
